enum CodeChangeState {
  NO_CHANGES,
  HAS_CHANGES,
}

export default CodeChangeState;